





















import Vue from 'vue';

export default Vue.extend({
  name: 'DashBoardCard',

  props: {
    noPadding: { type: Boolean, default: () => false },
    outlined: { type: Boolean, default: () => true }
  },

  computed: {
    dashboardContentClasses(): string {
      if (this.noPadding) return 'pa-0';
      return 'pa-4';
    },

    isLink(): boolean {
      return (
        !!this.$attrs['to'] || !!this.$attrs['href'] || !!this.$attrs['link']
      );
    },

    isClickable(): boolean {
      if (this.$attrs['disabled']) return false;

      return Boolean(
        this.isLink ||
          this.$listeners.click ||
          this.$listeners['!click'] ||
          this.$attrs['tabindex']
      );
    }
  }
});
